<template>
  <div
    v-if="items"
    class="grid grid-cols-1 flex-col gap-x-4 gap-y-8 sm:grid-cols-2 md:grid-cols-3"
  >
    <div v-for="item in videoItems" :key="item.id">
      <div
        class="relative mb-4 aspect-[327/246] overflow-hidden rounded-lg sm:aspect-[362/246]"
      >
        <UiVideo
          container-size
          :autoplay="false"
          :loop="false"
          :lazy="false"
          :controls="true"
          :muted="false"
          :src="item.file"
        />
      </div>

      <h5
        class="title text-sm uppercase leading-none tracking-[0.12em] text-slate"
        v-html="item.name"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { DocumentItem } from '@webplatform/frontkit/runtime/types';

interface Props {
  items?: DocumentItem[];
}

const props = withDefaults(defineProps<Props>(), {
  items: () => [],
});

const videoItems = computed(
  () => props.items?.filter((item) => item.file) ?? [],
);
</script>
